import { SurveyQuestionFragment, SurveyQuestionResponseStatistics } from '@occc/graphql';

import { BarPieceItem, PiePieceItem } from '../../../design-system';

export interface SurveyStatisticsGenericChartItem<ItemType> {
  type: ChartType;
  items: ItemType[];
}
export interface SurveyStatisticsPieChartItem
  extends SurveyStatisticsGenericChartItem<PiePieceItem> {
  type: 'pie';
  items: PiePieceItem[];
}
export interface SurveyStatisticsBarChartItem
  extends SurveyStatisticsGenericChartItem<
    BarPieceItem<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>
  > {
  type: 'bar';
  items: BarPieceItem<SurveyQuestionResponseStatistics['sliderResponseRanges'][0]>[];
}

export type ChartType = 'bar' | 'pie';

export const QuestionTypeToChartTypeMap: Record<SurveyQuestionFragment['__typename'], ChartType> = {
  SurveyQuestionIntSlider: 'bar',
  SurveyQuestionSingleChoice: 'pie',
  SurveyQuestionMultipleChoice: 'pie',
};
export const fallbackQuestionType: SurveyQuestionFragment['__typename'] = 'SurveyQuestionIntSlider';

export type DateRange = { startDate: Date; endDate: Date };
